import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { CreateLoginComponent } from './create-login.component';
import { GetStartComponent } from './get-start.component';
import { RegistrationTermsComponent } from './registration-terms';
import { PasswordPolicyComponent } from './password-policy.component';
import { CaptchaComponent } from '../app-components/captcha.component';
import { RecaptchaModule } from 'ng-recaptcha';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'get-start' },
  {
    path: 'get-start',
    component: GetStartComponent,
    data: { title: 'RunPayroll' }
  },
  {
    path: 'create-login',
    component: CreateLoginComponent,
    data: { title: 'Create your payroll login' }
  },
  {
    path: 'terms',
    component: RegistrationTermsComponent,
    data: { title: 'Terms' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), SharedModule, RecaptchaModule],
  declarations: [
    GetStartComponent,
    CreateLoginComponent,
    RegistrationTermsComponent,
    PasswordPolicyComponent,
    CaptchaComponent
  ]
})
export class RegistrationModule {}
